let load = require('./helpers/browser/esm-js-loader-shards-super.js')(4);
module.exports = (load("iUfTS")).then(() => parcelRequire('1O92x'));